import { ShieldCheck, Award, Zap, Wrench, BadgeCheck, Leaf } from "lucide-react";

const ITEMS = [
  { Icon: ShieldCheck, text: "Sicurezza Certificata" },
  { Icon: BadgeCheck, text: "Personale Formato Lavori in Quota" },
  { Icon: Award, text: "20+ Anni di Esperienza" },
  { Icon: Zap, text: "Materiali di Prima Scelta" },
  { Icon: Wrench, text: "Manutenzione Programmata" },
  { Icon: Leaf, text: "Energia 100% Pulita" },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="bg-white border-y border-[#E5E7EB]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-6">
        <div className="flex gap-8 md:gap-10 lg:gap-14 overflow-x-auto no-scrollbar items-center">
          {ITEMS.map((it) => (
            <div
              key={it.text}
              className="flex items-center gap-3 flex-shrink-0 text-[#4B5563]"
            >
              <it.Icon className="h-5 w-5 text-[#0F5132]" />
              <span className="text-sm font-medium uppercase tracking-wider whitespace-nowrap">
                {it.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
